module.exports = __webpack_public_path__ + "images/stepDarkBg.a824bc4f.svg";